export default "__VITE_ASSET__810cbd1e__"